import React, { useEffect, useState } from 'react';

import { Form } from 'react-bootstrap';
import ChatArea from '../pages/ChatArea';
import ListColor from './ListColor';
import ListImage from './ListImage';

interface ChatArea {
  corPrincial: string;
  setCorPrincial: (color: string) => void;
}

interface ChatAreaAparrenceProps {
  corPrincial: string;
  setCorPrincial: (color: string) => void;
  corFundo: string;
  setCorFundo: (color: string) => void;
  imagemFundo: string;
  setImagemFundo: (color: string) => void;
  corTextoOperador: string;
  setCorTextoOperador: (color: string) => void;
  corTextoCliente: string;
  setCorTextoCliente: (color: string) => void;
  corCaixaOperador: string;
  setCorCaixaOperador: (color: string) => void;
  corCaixaCliente: string;
  setCorCaixaCliente: (color: string) => void;

  corNomeOperadorCliente: string;
  setCorNomeOperadorCliente: (color: string) => void;
  corTitulo: string;
  setCorTitulo: (color: string) => void;
  opacidadeImagem: number;
  setOpacidadeImagem: (color: number) => void;
}

const ChatAreaAparrence = ({
  corPrincial,
  setCorPrincial,
  corFundo,
  setCorFundo,
  imagemFundo,
  setImagemFundo,
  corTextoOperador,
  setCorTextoOperador,
  corTextoCliente,
  setCorTextoCliente,
  corCaixaOperador,
  setCorCaixaOperador,
  corCaixaCliente,
  setCorCaixaCliente,
  corNomeOperadorCliente,
  setCorNomeOperadorCliente,
  corTitulo,
  setCorTitulo,
  opacidadeImagem,
  setOpacidadeImagem,
}: ChatAreaAparrenceProps): JSX.Element => {
  const colors = [
    '#009F23',
    '#008BEF',
    '#FFC107',
    '#EA00EF',
    '#1300EF',
    '#DE0000',
  ];

  const textColors = [
    '#FFFFFF',
    '#000000',
    '#828282',
    '#EA00EF',
    '#1300EF',
    '#DE0000',
  ];

  const [backgroundImagesList, setBackgroundImagesList] = useState([
    '42E14A06-39B1-4844-8F91-9DB83F1F561A.png',
    '90805E6D-F4DF-4D98-9A48-F0F8B7DBC298.png',
    '6682809E-54B7-43A3-B766-1A18105B96B4.png',
    '8AA1F9E9-20EA-4875-8002-FAB55C0ECE91.png',
    '6807A7A3-0D7A-48C6-968E-AAB68E57819C.png',
    '87FEF657-1985-4EF3-B474-285B638B5FD3.png',
    '5BA62401-89B0-4B4A-A72C-69219ECE5D93.png',
    '',
  ]);

  const addNewImage = (image: string): void => {
    if (image !== '' && !backgroundImagesList.includes(image)) {
      const updatedBackgroundImages = [...backgroundImagesList];
      updatedBackgroundImages[updatedBackgroundImages.length - 1] = image; // Atualiza o item na posição 5
      setBackgroundImagesList(updatedBackgroundImages);
    }
  };

  useEffect(() => {
    addNewImage(imagemFundo);
  }, [imagemFundo]);

  return (
    <div className="d-flex flex-column">
      <div className="d-flex align-items-center justify-content-center">
        <div
          style={{
            height: '12.5rem',
            width: '22rem',
            borderRadius: '0.68rem',
            boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
          }}
          className="overflow-hidden"
        >
          <ChatArea
            backgroundColorPrincipal={corPrincial}
            corFundo={corFundo}
            backgroundImage={imagemFundo}
            corTextoOperador={corTextoOperador}
            corTextoCliente={corTextoCliente}
            corCaixaOperador={corCaixaOperador}
            corCaixaCliente={corCaixaCliente}
            corNomeOperadorCliente={corNomeOperadorCliente}
            corTitulo={corTitulo}
            opacidadeImagem={opacidadeImagem}
          />
        </div>
      </div>
      <div className="">
        <div className="d-flex justify-content-between ms-1 mt-1 me-4">
          <div className="ms-3 mt-1">
            <span style={{ fontSize: '1.15rem', fontWeight: '600' }}>
              Cor texto operador
            </span>
            <ListColor
              colors={textColors}
              colorSelected={corTextoOperador}
              setColorSelected={setCorTextoOperador}
              positionShow="18rem"
              positionShowTop="0rem"
              showColorSelected
            />
          </div>
          <div className="ms-3 mt-1">
            <span style={{ fontSize: '1.15rem', fontWeight: '600' }}>
              Cor texto cliente
            </span>
            <ListColor
              colors={textColors}
              colorSelected={corTextoCliente}
              setColorSelected={setCorTextoCliente}
              positionShow="1rem"
              positionShowTop="0rem"
              showColorSelected
            />
          </div>
        </div>
        <div className="d-flex justify-content-between ms-1 mt-1 me-4">
          <div className="ms-3 mt-1">
            <span style={{ fontSize: '1.15rem', fontWeight: '600' }}>
              Cor caixa texto operador
            </span>
            <ListColor
              colors={colors}
              colorSelected={corCaixaOperador}
              setColorSelected={setCorCaixaOperador}
              positionShow="18rem"
              positionShowTop="-4.2rem"
              showColorSelected
            />
          </div>
          <div className="ms-3 mt-1">
            <span style={{ fontSize: '1.15rem', fontWeight: '600' }}>
              Cor caixa texto cliente
            </span>
            <ListColor
              colors={colors}
              colorSelected={corCaixaCliente}
              setColorSelected={setCorCaixaCliente}
              positionShow="1rem"
              positionShowTop="-4.2rem"
              showColorSelected
            />
          </div>
        </div>
        <div className="d-flex justify-content-between ms-1 mt-1 me-4">
          <div className="ms-3 mt-1">
            <span style={{ fontSize: '1.15rem', fontWeight: '600' }}>
              Cor nome operador/cliente
            </span>
            <ListColor
              colors={colors}
              colorSelected={corNomeOperadorCliente}
              setColorSelected={setCorNomeOperadorCliente}
              positionShow="18rem"
              positionShowTop="-4.2rem"
              showColorSelected
            />
          </div>
          <div className="ms-3 mt-1">
            <span style={{ fontSize: '1.15rem', fontWeight: '600' }}>
              Cor do título
            </span>
            <ListColor
              colors={colors}
              colorSelected={corTitulo}
              setColorSelected={setCorTitulo}
              positionShow="1rem"
              positionShowTop="-4.2rem"
              showColorSelected
            />
          </div>
        </div>
        <div className="d-flex flex-column justify-content-between ms-3 mt-2 me-4">
          <span style={{ fontSize: '1.15rem', fontWeight: '600' }}>
            Opacidade da imagem - {opacidadeImagem}%
          </span>
          <Form.Range
            min={0}
            max={100}
            style={{ width: '18rem' }}
            value={opacidadeImagem}
            onChange={(e) => setOpacidadeImagem(Number(e.currentTarget.value))}
          />
        </div>
        <div className="ms-3 mt-1">
          <span style={{ fontSize: '1.15rem', fontWeight: '600' }}>
            Plano de Fundo Principal
          </span>
          <ListImage
            backgroundImages={backgroundImagesList}
            backgroundColor={corFundo}
            setBackgroundColor={setCorFundo}
            backgroundImage={imagemFundo}
            setBackgroundImage={setImagemFundo}
            positionShow="28rem"
            addNewImage={addNewImage}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatAreaAparrence;
